import instance from "@/services/api";

export const getDataWith1C = async (params) => {
  return await instance()
    .get("/core/commons/one_c_compare/", {params})
    .then((res) => res?.data);
};